// extracted by mini-css-extract-plugin
export var card = "_a7-0";
export var expandedCard = "_a7-2";
export var paginated = "_a7-1";